import React, { useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useNotification } from '../common/NotificationContext';
import VisualizeDataPresenter from './VisualizeDataPresenter';

const VisualizeDataView = ({ activeTheme }) => {
  const [searchParams] = useSearchParams();
  const notify = useNotification();

  const filename = useMemo(() => {
    const search = window.location.search;
    const match = search.match(/[?&]filename=([^&]*)/);
    return match ? decodeURIComponent(match[1].replace(/\+/g, '%2B')) : null;
  }, []);

  const vin = useMemo(() => searchParams.get('vin'), [searchParams]);

  useEffect(() => {
    if (!filename) {
      notify({ message: 'No file specified. Please provide a filename parameter in the URL.', severity: 'error' });
    }
  }, [filename, notify]);

  if (!filename) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="body2" color="error" sx={{ mb: 1, fontWeight: 500 }}>
          No file specified.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Expected URL format: /bus_log?filename=path/to/file.parquet.zip&vin=VIN123
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <VisualizeDataPresenter
        file={filename}
        onError={(error) => console.error('VisualizeDataPresenter error:', error)}
      />
    </Box>
  );
};

export default VisualizeDataView;
